import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid";

interface ReasoningPanelProps {
  headlineKey?: string;
  reasoning: string;
  mitigations?: { reasoning: string }[];
}

export const ReasoningPanel = ({
  headlineKey = "risks.ai.detail.reasoning.headline",
  reasoning,
  mitigations,
}: ReasoningPanelProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="rounded-lg border border-gray-200 bg-white overflow-hidden border-l-4 border-l-cyan-400">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="w-full flex items-center justify-between px-4 py-3 text-left focus:outline-none"
      >
        <span className="text-sm font-semibold text-gray-900">
          {t(headlineKey)}
        </span>
        {isOpen ? (
          <ChevronUpIcon className="h-4 w-4 text-gray-400 flex-shrink-0" aria-hidden="true" />
        ) : (
          <ChevronDownIcon className="h-4 w-4 text-gray-400 flex-shrink-0" aria-hidden="true" />
        )}
      </button>

      {isOpen && (
        <div className="px-4 pb-4 border-t border-gray-100">
          <p className="text-sm text-gray-700 whitespace-pre-line pt-3">
            {reasoning}
          </p>

          {!!mitigations?.length && (
            <div className="mt-4">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                {t("risks.ai.detail.mitigationReasoning.headline")}
              </p>
              <ol className="space-y-2">
                {mitigations.map((mitigation, index) => (
                  <li key={index} className="text-sm text-gray-700">
                    <span className="font-medium">
                      {t("risks.ai.diff.section.mitigation", {
                        index: index + 1,
                      })}
                      {": "}
                    </span>
                    {mitigation.reasoning}
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
